// Hora oficial del sistema: Chile continental (America/Santiago, con horario de verano).
export const TZ_CL = "America/Santiago";

const partes = (d, opts) => Object.fromEntries(
  new Intl.DateTimeFormat("en-CA", { timeZone: TZ_CL, hourCycle: "h23", ...opts }).formatToParts(d).map((p) => [p.type, p.value])
);

// Date → "YYYY-MM-DD" en hora Chile
export const isoCL = (d = new Date()) => {
  const p = partes(d instanceof Date ? d : new Date(d), { year: "numeric", month: "2-digit", day: "2-digit" });
  return `${p.year}-${p.month}-${p.day}`;
};

export const hoyCL = () => isoCL(new Date());

// ISO UTC → "YYYY-MM-DD HH:mm" en hora Chile
export const fmtCL = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 16).replace("T", " ");
  const p = partes(d, { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}`;
};

// Todo el sistema muestra fechas/horas en hora Chile aunque el equipo tenga otra zona horaria.
export const forzarHoraChile = () => {
  if (Date.prototype.__horaChile) return;
  for (const m of ["toLocaleString", "toLocaleDateString", "toLocaleTimeString"]) {
    const orig = Date.prototype[m];
    Date.prototype[m] = function (loc, opts) { // eslint-disable-line no-extend-native
      return orig.call(this, loc, opts && opts.timeZone ? opts : { ...(opts || {}), timeZone: TZ_CL });
    };
  }
  const OrigDTF = Intl.DateTimeFormat;
  const DTF = function (loc, opts) { return new OrigDTF(loc, opts && opts.timeZone ? opts : { ...(opts || {}), timeZone: TZ_CL }); };
  DTF.prototype = OrigDTF.prototype;
  DTF.supportedLocalesOf = OrigDTF.supportedLocalesOf;
  Intl.DateTimeFormat = DTF;
  Date.prototype.__horaChile = true; // eslint-disable-line no-extend-native
};
